export const BANNER = `
 _   _             _      ___  _____  _____  _     _____
| \\ | |           | |    |_  |/  ___|/  __ \\| |   |_   _|
|  \\| |  ___  ___ | |_     | |\\ \`--. | /  \\/| |     | |
| . \` | / _ \\/ __|| __|    | | \`--. \\| |    | |     | |
| |\\  ||  __/\\__ \\| |_ /\\__/ //\\__/ /| \\__/\\| |_____| |_
\\_| \\_/ \\___||___/ \\__|\\____/ \\____/  \\____/\\_____/\\___/

`;
